import { render, staticRenderFns } from "./ModalReason.vue?vue&type=template&id=6e852d58"
import script from "./ModalReason.vue?vue&type=script&lang=js"
export * from "./ModalReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports